import PaymentCalculator from './PaymentCalculator.js';
/**
 * Handles leasing calculations
 */

class LeasePaymentCalculator extends PaymentCalculator {
  constructor({
    price = 0,
    down = 0,
    term = 72,
    rate = 0,
    residual = 0,
    tradein = 0,
    tax = 13
  } = {}) {
    super({
      price,
      tradein,
      tax,
      down,
      rate
    });
    this.term = term;
    this.residual = residual;
  }

  calculatePayments() {
    if (this.rate < 0) {
      this.payments = {
        'monthly': 0,
        'biweekly': 0,
        'weekly': 0
      };
      return;
    }

    let monthlyInterest = this.rate / 2400;
    this.payments.monthly = ((this.balance + this.residual) * monthlyInterest + (this.balance - this.residual) / this.term) * (1 + this.tax / 100);
    this.payments.biweekly = this.payments.monthly * 12 / 26;
    this.payments.weekly = this.payments.monthly * 12 / 52;
  }

  calculateBalance() {
    this.balance = this.price - this.tradein - this.down;
    return this.balance;
  }

  calculate() {
    this.calculateBalance();
    this.calculatePayments();
  }

}

export default LeasePaymentCalculator;
//# sourceMappingURL=LeasePaymentCalculator.js.map